import { updateIntl } from 'react-intl-redux';
import moment from 'moment';

import translations from '../../translations';
import { reportError } from './appActions';
import {
  loopbackPost,
  loopbackPut,
  loopbackGet,
  loopbackPatch,
} from '../../loopback';
import LoopbackProvider from '../../loopback/LoopbackProvider';

export * from './userActions';
export * from './surveyActions';
export * from './groundTruthActions';
export * from './trialActions';
export * from './trialCategoryActions';
export * from './certificateActions';
export * from './navigationActions';
export * from './appActions';
export * from './reviewActions';
export * from './voucherActions';
export * from './reviewCategoryActions';
export * from './feedbackAction';
export * from './instituteActions';
export * from './pageStateActions';
export * from './submissionActions';
export * from './surveyDataActions';
export * from './trialTagActions';
export * from './publicLinkActions';

export const approveEnrollment = (enrollmentId) => async (dispatch) => {
  try {
    await loopbackPost(`enrollments/${enrollmentId}/approve`);
  } catch (error) {
    dispatch(reportError(`Error during setting enrollment status: ${error.stack}`));
  }
};

export const rejectEnrollment = (enrollmentId) => async (dispatch) => {
  try {
    await loopbackPost(`enrollments/${enrollmentId}/reject`);
  } catch (error) {
    dispatch(reportError(`Error during setting enrollment status: ${error.stack}`));
  }
};

export const cancelInvoice = (enrollmentId) => async (dispatch) => {
  try {
    await loopbackPost(`enrollments/${enrollmentId}/cancelInvoice`);
  } catch (error) {
    dispatch(reportError(`Error during invoice invalidation status: ${error.stack}`));
  }
};

export const cancelEnrollment = (enrollmentId) => async (dispatch) => {
  try {
    await loopbackPost(`enrollments/${enrollmentId}/cancel`);
  } catch (error) {
    dispatch(reportError(`Error during setting enrollment status: ${error.stack}`));
  }
};

export const approveCertificate = (enrollmentId) => async (dispatch) => {
  try {
    await loopbackPost(`enrollments/${enrollmentId}/approveCertificate`);
  } catch (error) {
    dispatch(reportError(`Error during certificate approval: ${error.stack}`));
  }
};

export const createOrUpdateSubmission = (submissionData) => async (dispatch) => {
  try {
    return await loopbackPost('Submissions/createOrUpdate', { submissionData });
  } catch (error) {
    dispatch(reportError(`Error during submission creation: ${error.stack}`));
    throw error;
  }
};

export const createComplaint = (complaintData) => async (dispatch) => {
  try {
    return await loopbackPost('Complaint', complaintData);
  } catch (error) {
    return dispatch(reportError(`Error during creating complaint ${error.stack}`));
  }
};

export const importDeliveryList = (trialId, deliveryListData) => async (dispatch) => {
  try {
    return await loopbackPost(`trials/${trialId}/importDeliveryList`, { deliveryListData });
  } catch (error) {
    return dispatch(
      reportError(
        `Error during importing the delivery list for trial with id: ${trialId}: ${error.stack}`,
      ),
    );
  }
};

export const importDeliveryListV2 = (trialId, deliveryListData) => async (dispatch) => {
  try {
    return await loopbackPost(`trials/${trialId}/importDeliveryListV2`, { deliveryListData });
  } catch (error) {
    return dispatch(
      reportError(
        `Error during importing the delivery list for trial with id: ${trialId}: ${error.stack}`,
      ),
    );
  }
};

export const setLanguage = (language) => {
  LoopbackProvider.currentLanguage = language;
  return updateIntl({
    locale: language,
    messages: translations[language],
  });
};

export const resolvePendingPayment = (enrollment) => async (dispatch) => {
  try {
    await loopbackPut(`enrollments/${enrollment.id}`, {
      ...enrollment,
      paymentReceivedAt: moment.utc(),
    });
  } catch (error) {
    dispatch(
      reportError(`Error during resolving payment for enrollment: ${enrollment.id}: ${error.stack}`),
    );
  }
};

export const getOverallEvaluation = (trial) => async (dispatch) => {
  try {
    return await loopbackGet(`trials/${trial.id}/evaluation`);
  } catch (error) {
    return dispatch(
      reportError(
        `Error during accessing overall evaluation for trial: ${trial.id}: ${error.message}`,
      ),
    );
  }
};

export const downloadInvoicesZip = (trial) => () => loopbackGet(`Trials/${trial.id}/invoiceBundle`);
